import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-coverageSvg",
  "use": "icon-coverageSvg-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-coverageSvg\"><path d=\"M512 139.819L234.795 320 512 500.181 789.205 320 512 139.819zM938.667 320L512 597.333 85.333 320 512 42.667 938.667 320z\" /><path d=\"M147.499 426.667L512 681.173l364.501-254.506 62.166 43.434L512 768 85.333 470.101l62.166-43.434zm0 170.666L512 851.84l364.501-254.507 62.166 43.435L512 938.667 85.333 640.768l62.166-43.435z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol